module.exports = __webpack_public_path__ + "static/img/t1.f2df979.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/home/t1.png
// module id = C3SS
// module chunks = 1